/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Atl_RangeInputs */

const en_exp_atl_range = /** @type {(inputs: Exp_Atl_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relative to CTL: ATL significantly above CTL means high fatigue. ATL near or below CTL means you are well-recovered.`)
};

const de_exp_atl_range = /** @type {(inputs: Exp_Atl_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relativ zu CTL: ATL deutlich über CTL = hohe Ermüdung. ATL nahe oder unter CTL = gute Erholung.`)
};

/**
* | output |
* | --- |
* | "Relative to CTL: ATL significantly above CTL means high fatigue. ATL near or below CTL means you are well-recovered." |
*
* @param {Exp_Atl_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_atl_range = /** @type {((inputs?: Exp_Atl_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Atl_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_atl_range(inputs)
	return de_exp_atl_range(inputs)
});